angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/su', {
            templateUrl: 'superuser/superuser-user.html',
            title: 'User Admin',
            controller: 'SUAdminUserCtrl as admin',
            role: 'SUPERUSER'
        })

        .when('/su/clients', {
            templateUrl: 'superuser/superuser-client.html',
            title: 'Client Admin',
            controller: 'SUAdminClientCtrl as admin',
            role: 'SUPERUSER'
        });
});
